import { useMemo } from 'react';

import { FORM_COLLABORATION_MODES } from '../helpers/constants';

export const useShouldShowAssigneePicker = (
  formTemplate,
  isStatusExpansionEnabled,
) =>
  useMemo(() => {
    if (
      formTemplate.formCollaborationMode ===
      FORM_COLLABORATION_MODES.MULTIPLE_SEQUENCE
    ) {
      return true;
    }
    if (isStatusExpansionEnabled) {
      return !!(
        formTemplate.formCollaborationMode ===
          FORM_COLLABORATION_MODES.MULTIPLE_PARALLEL &&
        formTemplate.default_form_assignee_to_creator
      );
    }
    return false;
  }, [formTemplate, isStatusExpansionEnabled]);
